import React, { useState} from "react";
import { toast } from "react-toastify";

const SourcesTab = ({updateInstagramFeedTabData,instagramFeedTabData}) => {
    const [activeSourceType, setActiveSourceType] = useState(instagramFeedTabData.source_type);
    const [sourceSearchName, setSourceSearchName] = useState(instagramFeedTabData.source_search_name || "");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Handle Source Type change
    const handleActiveSourceTypeChange = (event) => {
        setActiveSourceType(event.target.value);
        updateInstagramFeedTabData("source_type", event.target.value);
    };
   
    // State to manage the submission status
    const submitSearchInstagramFeed = async (e, activeSourceType) => {
        e.preventDefault();

        if (!sourceSearchName.trim()) {
            if (activeSourceType === "account") {
                toast.error("Please enter Instagram Username or URL.");
            } else if (activeSourceType === "hashtag") {
                toast.error("Please enter Instagram Hashtag.");
            }
            return;
        }
        updateInstagramFeedTabData("source_search_name", sourceSearchName); 
        setIsSubmitting(true);

        // Simulate delay
        setTimeout(() => {
            setIsSubmitting(false);
        }, 1500); 
        
    };

    return (
        <div className="side-baar-inner-setting">
            <span>Add Instagram Source</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Source Type</span>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="source_type" className="card-input-element d-none" value="account" onChange={handleActiveSourceTypeChange} checked={activeSourceType === "account"} />
                            <div className="card card-body">
                                <div className="content_sub">Account</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="source_type" className="card-input-element d-none" value="hashtag" onChange={handleActiveSourceTypeChange} checked={activeSourceType === "hashtag"} />
                            <div className="card card-body">
                                <div className="content_sub">Hashtag</div>
                            </div>
                        </label>
                    </div>
                </div>
                <div className="source-serach-baar">
                    <div className="google-search-container">
                        {activeSourceType === 'account' && (
                            <input
                                type="text"
                                placeholder="Enter Username or url..."
                                value={sourceSearchName}
                                onChange={(e) => setSourceSearchName(e.target.value)}
                            />
                        )}
                        {activeSourceType === 'hashtag' && (
                            <input
                                type="text"
                                placeholder="Enter Instagram Hashtag..."
                                value={sourceSearchName}
                                onChange={(e) => setSourceSearchName(e.target.value)}
                            />
                        )}
                        <button
                            type="button"
                            onClick={(e) => submitSearchInstagramFeed(e, activeSourceType)}
                            disabled={isSubmitting}
                            className={isSubmitting ? "disabled" : ""}
                        >
                            {isSubmitting ? "Searching..." : "Search"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SourcesTab;